import APIService from '../api';
import { ReserveCoinInformations } from '@/models/coin-setup';

interface BusinessData {
  name: string;
  categoryId: string;
  otherCategory: string;
}

interface PersonalData {
  name: string;
  lastname: string;
}

export default class InviteMerchantSignupService extends APIService {
  updateBusinessInfo(code: string, businessData: BusinessData) {
    return this.put(`/business/basic-info`, {
      ...businessData,
      code
    });
  }

  updatePersonalInfo(code: string, personalData: PersonalData) {
    return this.put(`/customer/basic-info`, {
      ...personalData,
      code
    });
  }

  updateLocation(code: string, locationId: string, locationData: object) {
    return this.put(`/business-location/${locationId}/basic-info`, {
      ...locationData,
      code
    });
  }

  updateCoinSetup(code: string, reserveInformations: ReserveCoinInformations) {
    return this.post(`/admin/business-coin-setup/reserve-owner-claim`, {
      ...reserveInformations,
      code
    });
  }

  updateOffer(code: string, offerId: string, offerData: object) {
    return this.put(`/special-offer/${offerId}/basic-info`, {
      ...offerData,
      code
    });
  }

  deleteLocation(code: string, locationId: string) {
    return this.delete(`/business-location/${locationId}`, {
      code
    });
  }

  deleteOffer(code: string, offerId: string) {
    return this.delete(`/special-offer/${offerId}`, {
      code
    });
  }
}
